module.exports = __webpack_public_path__ + "img/slim07.bc83cc2c.jpg";